<template>
  <div>
    <div v-if="isProcessing">
      <div class="d-flex justify-content-center mb-3 mt-5">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
      <div class="col-12 text-center py-20">Trwa przesyłanie zamówienia</div>
    </div>
    <div v-else v-html="response"></div>
    <div v-if="errors.length">
      <b-row>
        <b-col lg="12">
          <b-card title="Napotkano błędy" class="title-inline">
            <b-card-text>
              <ul>
                <li v-for="error in errors" :key="error" class="text-danger">
                  {{ error }}
                </li>
              </ul>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <b-button
            variant="secondary"
            class="mx-3 ml-auto mb-2 btn-color"
            @click="backStep"
            >Wstecz
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'OrderSubmitted',
  data() {
    return {
      isProcessing: true,
      response: '',
      errors: [],
    };
  },
  created() {
    this.submitOrder();
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      orderSummary: 'order/summary',
      licence: 'auth/userLicence',
      policy: 'order/policy',
      currentOs: 'auth/currentOs',
      file: 'order/file',
    }),
  },
  methods: {
    submitOrder() {
      let order = new FormData();
      order.append('program', this.program);
      order.append('licence', this.licence);
      order.append('statement', this.file);
      order.append('order', JSON.stringify(this.orderSummary));
      order.append('policy', this.policy.toString());
      order.append('orderType', this.currentOs ? 'zam' : 'akt');

      axios
        .post('/api/submit-order', order, {
          headers: {
            'content-type': 'multipart/form-data',
          },
        })
        .then((response) => {
          this.isProcessing = false;
          this.response = response.data;
          this.$store.commit('order/resetOrder');
        })
        .catch((error) => {
          this.isProcessing = false;
          let that = this;
          $.each(error.response.data, function (key, value) {
            if (value[0]) {
              that.errors.push(value[0]);
            }
          });
        });
    },
    backStep() {
      this.$store.commit('order/decrementStep');
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  ul {
    list-style: none;
  }
}
</style>
